import { render } from "./ProgressCurve.vue?vue&type=template&id=718ccaee"
import script from "./ProgressCurve.vue?vue&type=script&lang=js"
export * from "./ProgressCurve.vue?vue&type=script&lang=js"
script.render = render

export default script